<template>
<div>
  <div id="wrapper">
    <div id="wheel">
      <div id="inner-wheel" ref="inner-wheel" :style="getWheelStyle">
        <div id="slice-container">
          <div v-for="(coupon, index) in coupons" :key="coupon.code"
            :ref="coupon.code"
            class="sec"
            :style="getSliceStyle(coupon, index)"
          >
            <div :style="getSliceTextStyle(index)">
              {{ (coupon.name || coupon.rewardName || coupon.valueId || '') | translate }}
            </div>
          </div>
        </div>
      </div>

      <div id="spin" @click="hitLottery" :class="{ disabled: spinning }">
        <div id="inner-spin">
          {{ $vuetify.lang.t('$vuetify.lottery.spin') }}
        </div>
      </div>

      <div id="shine"></div>
    </div>
  </div>

  <v-alert v-if="!!error" border="bottom" color="error">
    <h2 class="clear-text" style="margin-bottom: 20px">
      {{ $vuetify.lang.t('$vuetify.errorReport.main') }}
    </h2>
    <h4 class="clear-text">
      {{ error }}
    </h4>

    <v-btn v-if="showGoHome" color="info" style="margin-top: 20px; width: 100%" @click="goHome">
      {{ $vuetify.lang.t('$vuetify.common.home') }}
    </v-btn>
  </v-alert>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { api } from '@/plugins/api.service'

export default {
  props: ['coupons'],

  data() {
    return {
      error: null,
      spinning: false
    , showGoHome: false
    , autoHomeTimeout: null
    }
  },
  computed: {
    numSlices() {
      return (this.coupons || []).length
    },
    getWheelStyle() {
      let sliceSum = 0
      const colours = (this.coupons || []).map((coupon, index) => {
        const colour = this.genColour(index)
        sliceSum += coupon.chance

        return `${colour} 0%, ${colour} ${sliceSum}%`
      }).join(', ')

      return `{
        width: 100%;
        height: 100%;

        -webkit-transition: all 6s cubic-bezier(0,.99,.44,.99);
        -moz-transition:    all 6s cubic-bezier(0,.99,.44,.99);
        -o-transition:      all 6s cubic-bezier(0,.99,.44,.99);
        -ms-transition:     all 6s cubic-bezier(0,.99,.44,.99);
        transition:         all 6s cubic-bezier(0,.99,.44,.99);
        background: radial-gradient( circle closest-side, transparent 100%, white 0), conic-gradient(${colours});
      }`
    },

    ...mapGetters(['getStore', 'getUser', 'getAuthToken', 'getGuestTelephone', 'OWALink'])
  },

  methods: {
      goHome() {
        if (this.$route.name === 'CouponLottery') {
          this.$emit('goHomeReset');
        } else {
          this.$router.push({ name: 'CouponLottery' });
        }
      },
      setAutoHome() {
        if (this.autoHomeTimeout) clearTimeout(this.autoHomeTimeout);
        this.autoHomeTimeout = setTimeout(() => {
          this.goHome();
        }, 5000);
      },
    async hitLottery() {
      if (this.spinning) return; // Prevent multiple spins
      this.spinning = true;

      const UUID = function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };

      const skipLogin = this.getStore &&
        this.getStore.settings &&
        this.getStore.settings.luckyWheelSettings &&
        this.getStore.settings.luckyWheelSettings.skipLoginBeforeSpinning === true;

      let payload = { uuid: UUID() };

      if (skipLogin) {
        // Always use guest flow, ignore auth token/customerId
        payload.telephone = this.getGuestTelephone;
        try {
          const res = await api.post(`/lucky_wheel/spin`, payload);
          const { resultCode } = res.data;
          const index = this.coupons.findIndex(coupon => coupon.valueId == resultCode);
          this.spin(index);
        } catch (err) {
          this.error = (err.response && err.response.data && err.response.data.errorMsg) || 'You cannot spin right now';
          this.showGoHome = true;
          this.setAutoHome();
        }
      } else {
        try {
          const token = this.getAuthToken;
          const user = this.getUser;
          const customerId = user.id || null
          const telephone = user.telephone || null
          if (!token || !customerId) {
            this.error = 'Please login first';
            return;
          }
          await api.get(`lucky_wheel/validate_guest/${customerId}`);
          if (customerId) {
            payload.customerId = customerId;
          }
          if (telephone) {
            payload.telephone = telephone;
          }
          const spinRes = await api.post(`/lucky_wheel/spin`, payload);
          const { resultCode } = spinRes.data;
          const index = this.coupons.findIndex(coupon => coupon.valueId == resultCode);
          this.spin(index);
        } catch (err) {
          this.error = (err.response && err.response.data && err.response.data.errorMsg) || 'You cannot spin right now';
          this.showGoHome = true;
          this.setAutoHome();
        }
      }
    },

    spin(winningIndex) {
      // Spin the spinner while the wheel is moving fast
      const spinSpinner = async (index) => {
        if (index <= 0)
          return

        var element = document.getElementById('spin');
        element.classList.add('spin');

				setTimeout(function () {
					element.classList.remove('spin');
				}, 100);
        await setTimeout(() => spinSpinner(index-1), 750)
      }

      // Spin 5 times than arrive halfway between the winning degree
      const sliceDistance = [...this.coupons].splice(0, winningIndex+1).reduce((a, b) => a + b.chance, 0) - (this.coupons[winningIndex].chance/2)
      const sliceDegrees = ((sliceDistance / 100) * 360)
      const totalDegree = 1800-sliceDegrees;

      this.$refs['inner-wheel'].style.transform = `rotate(${totalDegree}deg)`

      spinSpinner(4)

      let _this = this
      setTimeout(function () {
        _this.$emit('spinnerFinished', _this.coupons[winningIndex])
        _this.spinning = false; // Only allow new spins after animation/result
      }, 7000);
    },

    getSliceStyle(coupon, index) {
      const sliceDistance = [...this.coupons].splice(0, index+1).reduce((a, b) => a + b.chance, 0) - (this.coupons[index].chance/2)
      const sliceDegrees = 180 + ((sliceDistance / 100) * 360)

      return `
        transform: rotate(${sliceDegrees}deg);
        -webkit-transform: rotate(${sliceDegrees}deg);
        -moz-transform: rotate(${sliceDegrees}deg);
        -o-transform: rotate(${sliceDegrees}deg);
        -ms-transform: rotate(${sliceDegrees}deg);
      `
    },

    getSliceTextStyle(index) {
      const sliceDistance = [...this.coupons].splice(0, index+1).reduce((a, b) => a + b.chance, 0) - (this.coupons[index].chance/2)
      const sliceDegrees = 180 + ((sliceDistance / 100) * 360)
      const angle = sliceDegrees < 360 ? 90 : 270
      const top = sliceDegrees < 360 ? 100 : 60

      return `
        top: ${top}px;
        transform: rotate(${angle}deg);
        -webkit-transform: rotate(${angle}deg);
        -moz-transform: rotate(${angle}deg);
        -o-transform: rotate(${angle}deg);
        -ms-transform: rotate(${angle}deg);

        font-size: 15px;
        color: white;
      `
    },

    genColour(index) {
      if (this.numSlices == 5 || this.numSlices == 9 || this.numSlices == 13) {
        if (index % 3 == 0)
          return '#39A9DB'
        if (index % 3 == 1)
          return '#F96E46'
        if (index % 3 == 2)
          return '#44AF69'
      }

      if (index % 4 == 0)
        return '#39A9DB'
      if (index % 4 == 1)
        return '#F96E46'
      if (index % 4 == 2)
        return '#44AF69'
      if (index % 4 == 3)
        return '#FFE066'
    }
  },

  mounted() {
    const skipLogin = this.getStore &&
      this.getStore.settings &&
      this.getStore.settings.luckyWheelSettings &&
      this.getStore.settings.luckyWheelSettings.skipLoginBeforeSpinning === true;
    if (!skipLogin && this.getUser && this.getUser.id) {
      api.get(`lucky_wheel/validate_guest/${this.getUser.id}`).catch(res => {
        this.error = res.response.data.errorMsg || 'You cannot spin right now'
        this.showGoHome = true;
        this.setAutoHome();
      })
    }
  }
}
</script>

<style scoped>
  .clear-text {
    color: white;
    text-shadow: -0.5px -0.5px 0 black, 0.5px -0.5px 0 black, -0.5px 0.5px 0 black, 0.5px 0.5px 0 black;
  }
  .v-alert {
    position: absolute;
    top: 40%;
    left: calc(50% - 175px);

    width: 350px;

    color: white;
  }
  a {
    text-decoration: none;
  }


  /*WRAPPER*/
  #wrapper{
    margin: 0px auto 0;
    width: 50vh;
    min-width: 300px;
    max-width: 600px;
    position:relative;
  }


  /*WHEEL*/
  #wheel {
    width: 50vh;
    min-width: 300px;
    max-width: 600px;
    height: 50vh;
    min-height: 300px;
    max-height: 600px;
    border-radius:50%;
    position:relative;
    overflow:hidden;
    border:8px solid #fff;
    box-shadow:rgba(0,0,0,0.2) 0px 0px 10px, rgba(0,0,0,0.05) 0px 3px 0px;
    transform: rotate(0deg);
  }

  @media only screen and (max-width: 768px) {
    #wrapper{
      max-width: 90vw;
    }

    #wheel {
      max-width: 90vw;
      max-height: 90vw;
    }
  }

  #wheel #slice-container {
    width: 50%;
    height: 50%;
    position:absolute;
    top:50%;
    left:50%;
    width: 0;
    height: 0;
  }
  #wheel div.sec div {
    position: absolute;
    left: -60px;
    top: 100px;
    text-align: left;

    width: 120px;

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  #spin {
    width:68px;
    height:68px;
    position:absolute;
    top:50%;
    left:50%;
    margin:-34px 0 0 -34px;
    border-radius:50%;
    box-shadow:rgba(0,0,0,0.1) 0px 3px 0px;
    z-index:1000;
    background:#B51399;
    cursor:pointer;
    font-family: 'Exo 2', sans-serif;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  #spin.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  #spin:after{
    /* content:"SPIN"; */
    /* text-align:center;
    line-height:68px;
    color:white; */
    /* text-shadow: 0 2px 0 #fff, 0 -2px 0 rgba(0,0,0,0.3) ; */
    position: relative;
    z-index: 100000;
    width:68px;
    height:68px;
    display:block;
  }

  #spin:before{
    content:"";
    position:absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 20px 28px 20px;
    border-color: transparent transparent #B51399 transparent;
    top:-12px;
    left:14px;
  }

  #inner-spin {
    text-align:center;
    line-height:58px;
    color:white;

    width:54px;
    height:54px;
    position:absolute;
    top:50%;
    left:50%;
    margin:-27px 0 0 -27px;
    border-radius:50%;
    background:red;
    z-index:999;
    box-shadow:rgba(181,19,153,1) 0px -2px 0px inset, rgba(181,19,153,1) 0px 2px 0px inset,  rgba(0,0,0,0.4) 0px 0px 5px ;

    background: rgb(181,19,153); /* Old browsers */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#eaeaea',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
  }

  #spin:active #inner-spin{
    box-shadow:rgba(0,0,0,0.4) 0px 0px 5px inset;
  }

  #spin:active:after{
    font-size:15px;
  }


  #shine{
    width: 100%;
    height: 100%;
    position:absolute;
    top:0;
    left:0;
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    opacity:0.1;
  }



  /*ANIMATION*/
  @-webkit-keyframes hh {
    0%, 100%{
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }

    50%{
      transform: rotate(7deg);
      -webkit-transform: rotate(7deg);
    }
  }

  @keyframes hh {
    0%, 100%{
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }

    50%{
      transform: rotate(7deg);
      -webkit-transform: rotate(7deg);
    }
  }

  .spin {
    -webkit-animation: hh 0.1s; /* Chrome, Safari, Opera */
    animation: hh 0.1s;
  }
</style>
